import React, { useMemo } from "react";
import RhsContent from "@tripbuilder/views/right";
import { Trip, Location, TransportData, TripTransport } from "@/types/trip";
import { ServerFlightInfo } from "@/types/flights";
import TransportContainer from "@tripbuilder/cat-transport/right/TransportContainer";
import useViewStore from "@/stores/tripBuilder/useView";

interface TripRightContentProps {
  switchToSchedule: () => void;
  tripData: Trip | null;
  isAddDestinationModalOpen: boolean;
  transportData: TransportData;
  selectedFlight: TripTransport | null;
  setSelectedFlight: (flight: TripTransport | null) => void;
  addFlightToTrip: (
    trip: Trip,
    flight: ServerFlightInfo,
    transportData: TransportData
  ) => void;
  flightModalOpen: boolean;
  setFlightModalOpen: (isOpen: boolean) => void;
  handleTransportButtonClick: (location: Location) => void;
  setIsModalOpen: (isOpen: boolean) => void;
}

const TripRightContent: React.FC<TripRightContentProps> = ({
  switchToSchedule,
  tripData,
  isAddDestinationModalOpen,
  transportData,
  selectedFlight,
  setSelectedFlight,
  addFlightToTrip,
  flightModalOpen,
  setFlightModalOpen,
  handleTransportButtonClick,
  setIsModalOpen,
}) => {
  const panel = useViewStore((state) => state.panel);
  const activeTab = useViewStore((state) => state.activeTab);
  const content = useMemo(() => {
    switch (panel) {
      case "locations":
        return (
          <RhsContent
            activeTab={activeTab}
            switchToSchedule={switchToSchedule}
            tripData={tripData}
            isAddDestinationModalOpen={isAddDestinationModalOpen}
            handleTransportButtonClick={handleTransportButtonClick}
            setIsModalOpen={setIsModalOpen}
          />
        );
      case "transport":
        return (
          <TransportContainer
            transportData={transportData}
            selectedFlight={selectedFlight}
            setSelectedFlight={setSelectedFlight}
            addFlightToTrip={addFlightToTrip}
            flightModalOpen={flightModalOpen}
            setFlightModalOpen={setFlightModalOpen}
          />
        );
      default:
        return (
          <RhsContent
            activeTab={activeTab}
            switchToSchedule={switchToSchedule}
            tripData={tripData}
            isAddDestinationModalOpen={isAddDestinationModalOpen}
            handleTransportButtonClick={handleTransportButtonClick}
            setIsModalOpen={setIsModalOpen}
          />
        );
    }
  }, [
    panel,
    activeTab,
    switchToSchedule,
    tripData,
    isAddDestinationModalOpen,
    transportData,
    selectedFlight,
    setSelectedFlight,
    addFlightToTrip,
    flightModalOpen,
    setFlightModalOpen,
    handleTransportButtonClick,
    setIsModalOpen,
  ]);

  return (
    <div className="max-w-[43.5%] px-4 h-screen min-w-[43.5%] w-[43.5%] relative flex flex-col items-center justify-start mt-1">
      {content}
    </div>
  );
};

export default TripRightContent;
